import React, { ChangeEvent } from "react";

interface PhoneNumberInputProps {
  className: string;
  name: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  className,
  name,
  placeholder,
  value,
  onChange,
}) => {
  const formatPhoneNumber = (input: string) => {
    const numericValue = input.replace(/\D/g, "");

    let formattedValue = numericValue;

    if (numericValue.length > 2) {
      const ddd = numericValue.slice(0, 2);
      const prefix = numericValue.slice(2, 7);
      const number = numericValue.slice(7);

      formattedValue = `(${ddd}) ${prefix}-${number}`;
    }

    return formattedValue;
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (newValue.length <= 15) {
      const formattedValue = formatPhoneNumber(newValue);
      onChange(formattedValue);
    }
  };

  return (
    <input
      type="text"
      className={className}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={handleInputChange}
    />
  );
};

export default PhoneNumberInput;
